import React from 'react';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Flex,
  ListItem,
  VisuallyHidden,
} from '@/components/ui';
import {
  IconClipboardList,
  IconDots,
  IconEye,
  IconTrash,
  IconWand,
  IconX,
} from '@tabler/icons-react';
import { StudyForm } from './types';

interface MappingActionsProps {
  selectedForm: StudyForm | null;
  fileName: string;
  onPreview: () => void;
  onFormDetails: () => void;
  onClearMapping: () => void;
  onRemoveFile: () => void;
  onAutoMapForm?: () => void;
  onAutoMapColumns?: () => void;
  onAutoMapFormAndColumns?: () => void;
}

export const MappingActions: React.FC<MappingActionsProps> = ({
  selectedForm,
  fileName,
  onPreview,
  onFormDetails,
  onClearMapping,
  onRemoveFile,
  onAutoMapForm,
  onAutoMapColumns,
  onAutoMapFormAndColumns,
}) => {
  void fileName;
  return (
    <Flex justify="end" gap="1">
      <VisuallyHidden>
        <Button
          variant="soft"
          size="xsmall"
          onClick={onPreview}
          startIcon={<IconEye />}
          title="Preview file"
        >
          Preview
        </Button>
      </VisuallyHidden>

      <DropdownMenu>
        <DropdownMenuTrigger>
          <Button variant="text" isIconOnly size="medium" title="More actions">
            <IconDots />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent variant="soft">
          <DropdownMenuItem asChild>
            <ListItem
              startIcon={<IconEye />}
              primary="Preview File"
              onClick={onPreview}
            />
          </DropdownMenuItem>
          {onAutoMapForm || onAutoMapColumns || onAutoMapFormAndColumns ? (
            <>
              {onAutoMapForm && (
                <DropdownMenuItem asChild>
                  <ListItem
                    startIcon={<IconWand />}
                    primary="Auto-map form"
                    onClick={onAutoMapForm}
                  />
                </DropdownMenuItem>
              )}
              {onAutoMapColumns && (
                <DropdownMenuItem asChild>
                  <ListItem
                    startIcon={<IconWand />}
                    primary="Auto-map columns"
                    onClick={onAutoMapColumns}
                  />
                </DropdownMenuItem>
              )}
              {onAutoMapFormAndColumns && (
                <DropdownMenuItem asChild>
                  <ListItem
                    startIcon={<IconWand />}
                    primary="Auto-map form and columns"
                    onClick={onAutoMapFormAndColumns}
                  />
                </DropdownMenuItem>
              )}
            </>
          ) : null}
          {selectedForm ? (
            <>
              <DropdownMenuItem asChild>
                <ListItem
                  startIcon={<IconClipboardList />}
                  primary="View Form Details"
                  onClick={onFormDetails}
                />
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <ListItem
                  startIcon={<IconX />}
                  primary="Clear Mapping"
                  onClick={onClearMapping}
                />
              </DropdownMenuItem>
            </>
          ) : null}
          <DropdownMenuItem color="ruby" asChild>
            <ListItem
              startIcon={<IconTrash />}
              primary="Remove File"
              onClick={onRemoveFile}
            />
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </Flex>
  );
};
